<template>
	<div class="refined-content">
		<!-- 导航条 -->
		<BaseNav></BaseNav>
		<a-spin :spinning="loading">
			<div class="content">
				<img class="head-bg" :src="headBg" alt="">
			</div>

			<div class="container">
				<!-- 金刚位4个 -->
				<div class="action-box">
					<div class="item" v-for="(item,index) in introduceList">
						<img class="bg" :src="imagePath + item.imageUrl" alt="">
						<div class="item-content">
							<div class="name">{{item.name}}</div>
							<div class="button"  @click="toAction(index)">{{item.buttonName}}</div>
						</div>
					</div>
				</div>

				<!-- 新闻动态 -->
				<div class="news-box">
					<div class="swiper-box">
						<newsSwiper :list="recommendNews" :type="1" width="574px" height="392px" radius="0px"></newsSwiper>
					</div>
					<div class="news-list">
						<div class="title">
							<div class="flex align-center">
								<div class="line"></div>
								<div class="color-1a margin-left-5 font-28">专板动态</div>
							</div>
							<router-link tag="a" :to="{path:'/news/list',query:{homeMenuFirstId:activeNewsList.newsType.homeMenuFirstId,menuPosition:menuPosition,newsType:activeNewsList.newsType.id}}">
								<img @mouseleave="moreLeave" @mouseenter="moreEnter" :src="moreIcon" alt="">
							</router-link>
						</div>
						<div v-if="activeNewsList!=''">
							<div class="item border-bottom-dott padding-tb-15 flex justify-between align-center hover-item" v-for="(item,index) in activeNewsList.pageList.records">
								<div class="item-title color-1a font-16 overflow-eli">
									<router-link class="hover-a line-1" tag="a" :to="{path:'/news/info',query:{newsId:item.id}}">
										{{item.newsTitle}}
									</router-link>
								</div>
								<div class="time color-999">{{item.releaseTime}}</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="bg-gray">
				<div class="container">
					<!-- 特色服务 -->
					<div class="feature">
						<div class="title">
							<div class="flex align-center">
								<div class="line"></div>
								<div class="color-1a margin-left-5 font-28">特色服务</div>
							</div>
						</div>
						<div class="contents">
							<!-- <div class="item" v-for="(item,index) in serviceList" :key="index">
								<div class="item-title">
									<img :src="imagePath + item.logo" class="icon" />
									<div class="text">{{item.name}}</div>
								</div>
								<div class="list">
									<div class="tag" v-for="(tag,tindex) in item.content" key="tindex">{{tag}}</div>
								</div>
								<div class="list" v-if="index==0 || index==2">
									<div class="tag w-100" v-for="(tag,tindex) in item.content" :key="tindex" v-if="tag.length>6">{{tag}}</div>
									<div class="tag w-50" v-for="(tag,tindex) in item.content" :key="tindex" v-if="tag.length>=4 && tag.length<=6">{{tag}}</div>
									<div class="tag w-30" v-for="(tag,tindex) in item.content" :key="tindex" v-if="tag.length<4">{{tag}}</div>
								</div>
								<div class="list" v-if="index==1">
									<div class="tag w-100" v-for="(tag,tindex) in item.content" :key="tindex" v-if="tag.length>8">{{tag}}</div>
									<div class="tag w-50" v-for="(tag,tindex) in item.content" :key="tindex" v-if="tag.length<=8">{{tag}}</div>
								</div>
							</div> -->
							<div class="item">
								<div class="item-title">
									<img src="@/assets/refined/icon-1.png" class="icon">
									<div class="text">十大重点服务产品</div>
								</div>
								<div class="list">
									<div class="tag w-50">上市苗圃计划</div>
									<div class="tag w-50">新三板直通车</div>
									<div class="tag w-100">“冀之星”投融资路演</div>
									<div class="tag w-50">企业互助宝</div>
									<div class="tag w-50">股权无忧</div>
									<div class="tag w-50">金种子工程</div>
									<div class="tag w-50">数字赋企</div>
									<div class="tag w-30">冀企融</div>
									<div class="tag w-30">易企贷</div>
									<div class="tag w-30">周转通</div>
								</div>
							</div>
							<div class="item">
								<div class="item-title">
									<img src="@/assets/refined/icon-2.png" class="icon">
									<div class="text">七大专属服务体系</div>
								</div>
								<div class="list">
									<div class="tags w-100">
										<div>上市培育服务</div>
										<div>（河北省企业上市服务联盟）体系</div>
									</div>
									<div class="tag w-50">资源对接服务体系</div>
									<div class="tag w-50">企业融智服务体系</div>
									<div class="tag w-50">投融资服务体系</div>
									<div class="tag w-50">登记托管服务体系</div>
									<div class="tag w-100">数字化服务体系</div>
									<div class="tag w-100">金融产权交易服务体系</div>
								</div>
							</div>
							<div class="item">
								<div class="item-title">
									<img src="@/assets/refined/icon-3.png" class="icon">
									<div class="text">五大服务平台</div>
								</div>
								<div class="list">
									<div class="tag w-100">河北股权托管交易平台</div>
									<div class="tag w-100">沪深北证券交易所服务基地</div>
									<div class="tag w-100">河北省股改上市服务平台</div>
									<div class="tag w-100">金融资产交易服务平台</div>
									<div class="tag w-100">国家中小企业公共服务示范平台</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="container">
				<div class="zhengce">

					<div class="contents">
						<div class="left">
							<div class="title">
								<div class="flex align-center">
									<div class="line"></div>
									<div class="color-1a margin-left-5 font-28">专精特新政策库</div>
								</div>
							</div>
							<div class="top">
								<div class="tabs">
									<div class="tab-item" :class="currentTab==index?'active':''" @click="tabChange(index)" v-for="(item,index) in newsList" :key="index">{{item.newsType.newsType}}</div>
								</div>
								<router-link tag="a" :to="{path:'/news/list',query:{homeMenuFirstId:currentNewsList.newsType.homeMenuFirstId,menuPosition:menuPosition,newsType:currentNewsList.newsType.id}}">
									<img @mouseleave="moreLeave" @mouseenter="moreEnter" :src="moreIcon" alt="">
								</router-link>
							</div>
							<div class="list" v-if="currentNewsList!=''">
								<div class="item border-bottom-dott padding-tb-14 flex justify-between align-center hover-item" v-for="(item,index) in currentNewsList.pageList.records" :key="index">
									<div class="item-title color-1a font-16 overflow-eli">
										<div class="tag">{{currentNewsList.newsType.newsType}}</div>
										<router-link class="hover-title hover-a line-1" tag="a" :to="{path:'/news/info',query:{newsId:item.id}}">
											{{item.newsTitle}}
										</router-link>
									</div>
									<div class="time color-999">{{item.releaseTime}}</div>
								</div>
							</div>
						</div>
						<div class="right">
							<div class="daikuan-title">
								<!-- <img src="@/assets/refined/daikuan_bg.png" class="header" alt=""> -->
								<div class="title">创新专属金融产品</div>
								<!-- <div class="sub-title">创新专属金融产品一键直达</div> -->
							</div>
							<a-carousel autoplay :dots="true">
								<div v-for="(item,index) in masteryLoanList" :key="index">
									<div class="bank-list">
										<div class="bank-item" v-for="(child,cIndex) in item" :key="cIndex">
											<img :src="imagePath + child.bankLogo" class="logo" alt="">
											<div class="name">{{child.name}}</div>
											<div class="sub">贷款额度</div>
											<div class="price">{{child.limits}}元</div>
											<div class="lv-name">参考利率（年化）</div>
											<div class="lv-number">{{child.interestrate}}</div>
											<div class="btn" @click="masteryShow(child)">产品详情</div>
										</div>
									</div>
								</div>
							</a-carousel>
						</div>
					</div>
				</div>

			</div>

			<div class="bg-gray">
				<div class="container">
					<!-- 相关活动 -->
					<div class="active-box">
						<div class="title">
							<div class="flex align-center">
								<div class="line"></div>
								<div class="color-1a margin-left-5 font-28">相关活动</div>
							</div>
						</div>
						<div class="contents">
							<div class="left">
									<div class="active-item"  v-for="(item,index) in activityList" :key="index" @click="activityDetail(item.id)">
										<div class="item-left">
											<img :src="imagePath + item.imageUrl" class="thumb" alt="" />
										</div>
										<div class="item-right">
											<div class="item-right-title">{{item.activityName}}</div>
											<div class="time">活动时间：{{item.activityTime}}</div>
											<div class="address">活动地点：{{item.activityAddress}}</div>
											<div class="btn" v-if="item.status==0">我要报名</div>
											<!-- <div class="btn-no" v-if="item.status!=0">不可报名</div> -->
										</div>
									</div>
							</div>
							<div class="right">
								<div class="right-title">活动日历</div>
								<div class="step">
									<a-steps progress-dot :current="activityDateList.length" direction="vertical">
										<a-step v-for="(item,index) in activityDateList" :key="index" :title="item.activityTime" :description="item.activityName" />
									</a-steps>
								</div>
							</div>
						</div>
						<div class="btn-group">
							<div class="btn" @click="moreActivity">更多活动</div>
						</div>
					</div>
				</div>
			</div>
		</a-spin>


		<a-modal v-model="masteryModal" :title="currentMastery.name" @ok="masteryModal = false" width="800px" :footer="null">
		     <div style="height: 650px;line-height:1.8em;overflow-y: auto;padding:15px;" v-html="currentMastery.details"></div>
		</a-modal>

		<a-modal v-model="actionShow" @ok="actionShow = false" width="800px" :footer="null">
			<iframe :key="iframeKey" id="action" :src="currentAction.url" class="frame" :style="{height:frameHeight,overflowY:'hidden'}" frameborder="0"></iframe>
		</a-modal>

		<!-- <a-modal v-model="actionShow2" title="专精测评" @ok="actionShow2 = false" width="1200px" :footer="null">
			<iframe src="/#/refined/assess" class="frame" frameborder="0"></iframe>
		</a-modal>

		<a-modal v-model="actionShow3" title="上市测评" @ok="actionShow3 = false" width="1200px" :footer="null">
			<iframe src="/#/refined/listing" class="frame" frameborder="0"></iframe>
		</a-modal> -->
		<!-- 底部 -->
		<BaseFooter></BaseFooter>
	</div>
</template>

<script>
	import newsSwiper from "@/components/NewsSwiper"
	import BaseNav from "@/components/BaseNavigation"
	import BaseFooter from "@/components/BaseFooter"
  import Alliance from "./alliance/index.vue"
  import Assess from "./assess/index.vue"
	export default{
		components: {
			BaseNav,
			BaseFooter,
			newsSwiper,
      Alliance,
      Assess,
		},
		data(){
			return{
				loading:true,
				headBg:"",
				imagePath:this.$api.baseUrl + this.$api.imgPath,
				serviceList:[], //特色服务
				recommendNews:[], //推荐新闻
				activeNewsList:[], //新闻动态
				newsList:[], //政策列表
				currentNewsList:[],
				masteryLoanList:[], //贷款列表
				activityList:[], //活动列表
				activityDateList:[], //活动日历
				currentTab:0,
				moreIcon: require("../../assets/more.png"),
				moreIconActive: require("../../assets/more_active.png"),
				menuId:"1797794333386158082",
				menuPosition:"1797792483337383937",
				activitySearch:{pageNo:1,pageSize:3},
				activityLastPage:0,
				masteryModal:false,
				actionShow:false,
				currentMastery:{}, //当前选中的贷款产品
				introduceList:[], //入板列表
				currentAction:{name:"",url:""},
				iframeKey:0,
				frameHeight:"",
			}
		},
		created(){
			document.title = "雄安股权交易所-专精特新";
			this.getHeadBanner()
			this.queryMasteryServiceList()
			this.getRecommendNews()
			this.getNewsType()
			this.queryMasteryLoanList()
			this.queryMasteryActivityPageList()
			this.queryActivityDateList()
			this.getIntroduceList()
		},
		methods:{
			toAction(index){
				this.currentAction = this.introduceList[index];
				if(this.currentAction.type==4){
					this.frameHeight = "574px";
					this.currentAction.url = "/#/refined/alliance?id="+this.currentAction.id;
				}
				if(this.currentAction.type==3){
					this.frameHeight = "574px";
					this.currentAction.url = "/#/refined/sensible?id="+this.currentAction.id;
				}
				if(this.currentAction.type==2){
					this.frameHeight = "574px";
					this.currentAction.url = "/#/refined/assess?id="+this.currentAction.id;
				}
				if(this.currentAction.type==1){
					// this.frameHeight = "552px";
					// this.currentAction.url = "/#/refined/listing?id="+this.currentAction.id;
					window.open("https://biz.hebotc.com/#/specializationNewList");
					return false;
				}
				this.iframeKey++
				this.actionShow = true;
			},
			//获取入板列表
			getIntroduceList(){
				this.$request({
					url:this.$api.refined.queryIntroduceList
				}).then((res)=>{
					this.introduceList = res.data.result;
				})
			},
			// 活动详情
			activityDetail(id){
				this.$router.push({path:"/activity/detail",query:{activity:id}})
			},
			//查看更多活动
			moreActivity(){
				if(this.activitySearch.pageNo < this.activityLastPage){
					this.activitySearch.pageNo ++
					this.queryMasteryActivityPageList()
				}else{
					this.$message.warning('没有更多了');
				}
			},
			//活动列表
			queryMasteryActivityPageList(){
				this.$request({
					url:this.$api.refined.queryMasteryActivityPageList,
					data:this.activitySearch
				}).then((res)=>{
					this.activityList = [...this.activityList,...res.data.result.records];
					this.activityLastPage = res.data.result.pages;
				})
			},
			//获取活动日历
			queryActivityDateList(){
				this.$request({
					url:this.$api.refined.queryMasteryActivityPageList,
					data:{pageNo:1,pageSize:10}
				}).then((res)=>{
					this.activityDateList = res.data.result.records;
				})
			},
			//贷款产品显示弹窗
			masteryShow(item){
				this.currentMastery = item;
				this.masteryModal = true;
			},
			//贷款产品
			queryMasteryLoanList(){
				this.$request({
					url:this.$api.refined.queryMasteryLoanList,
				}).then((res)=>{
					let result = res.data.result;
					this.masteryLoanList = this.$utils.array_chunk(result,2);
				})
			},
			//获取新闻动态
			getNewsType(){
				this.$request({
					url:this.$api.news.getNewsType,
					data:{menuId:this.menuId}
				}).then((res)=>{
					let result = res.data.result;
					result.map((item,index)=>{
						if(index==0){
							this.activeNewsList = item;
						}else{
							this.newsList.push(item)
						}
					})
					if(this.newsList[0]){
						this.currentNewsList = this.newsList[0];
					}
					this.loading = false;
				})
			},
			//获取特色服务
			queryMasteryServiceList(){
				this.$request({
					url:this.$api.refined.queryMasteryServiceList,
				}).then((res)=>{
					this.serviceList = res.data.result;
					this.serviceList.map((item)=>{
						item.content = item.content.split(",")
						return item;
					})

				})
			},
			//获取推荐新闻
			getRecommendNews(){
				this.$request({
					url:this.$api.news.getRecommendNews,
					data:{menuId:this.menuId}
				}).then((res)=>{
					this.recommendNews = res.data.result;
				})
			},

			autoIframeHeight(iframe) {
			    var iframeBody = iframe.contentDocument || iframe.contentWindow.document;
			    var iframeBodyStyle = iframeBody.body.style;
			    iframeBodyStyle.margin = '0';
			    iframeBodyStyle.padding = '0';
			    var iframeHeight = iframeBody.body.scrollHeight;
			    iframe.style.height = iframeHeight + 'px';
			},
			//获取背景图
			getHeadBanner() {
				this.$request({
					url: this.$api.public.getBanner,
					data: {
						menuPosition: this.menuPosition,
						type: 1
					}
				}).then((res) => {
					this.headBg = this.$api.baseUrl + this.$api.imgPath + res.data.result[0].pcImageUrl;
				})
			},
			tabChange(e){
				this.currentTab = e;
				this.currentNewsList = this.newsList[e];
			},
			moreEnter(e) {
				e.target.src = this.moreIconActive;
			},
			moreLeave(e) {
				e.target.src = this.moreIcon;
			}
		}
	}
</script>
<style>

	.ant-steps-dot .ant-steps-item-content, .ant-steps-dot.ant-steps-small .ant-steps-item-content{
		width: auto;
	}

	.ant-modal-body{
		padding:0;
		margin:0;
		line-height: 0;
	}

	.ant-steps-vertical .ant-steps-item-description{
		background-color: #f6fafd;
		padding:12px;
		color: #333 !important;
		margin-top: 10px;
		margin-bottom: 10px;
	}
</style>
<style scoped>
	.active-box{
		padding-top: 50px;
		padding-bottom: 50px;
	}

	.head-bg {
		width: 100%;
		min-width: 1200px;
		height: 496px;
		object-fit: cover;
	}

	.bg-gray{
		background-color: #f0f7fd;
	}

	.action-box{
		margin-top: 50px;
		margin-bottom: 50px;
		display: flex;
		flex-flow: row nowrap;
		justify-content:space-between;
	}

	.action-box .item{
		width: 260px;
		height: 165px;
		position: relative;
		border-radius:8px;
	}

	.action-box .item .bg{
		width: 100%;
		height: 100%;
		object-fit: cover;
		z-index: 1;
		position: relative;
		border-radius:8px;
	}

	.action-box .item .item-content{
		width: 100%;
		height: 100%;
		z-index:999;
		position: absolute;
		top:0;
		left:0;
		background: linear-gradient(90deg, rgba(22,81,217,1) 0%, rgba(255,255,255,0) 100%);
		border-radius:8px;
	}

	.action-box .item .item-content .name{
		font-size: 22px;
		color: #fff;
		font-weight: bold;
		position: absolute;
		top:40px;
		left:20px;
	}

	.action-box .item .item-content .button{
		font-size: 16px;
		color: #fff;
		position: absolute;
		cursor: pointer;
		bottom:30px;
		left:20px;
		border: 1px solid #fff;
		border-radius:10px;
		padding:5px 20px;
	}

	.news-box{
		display: flex;
		justify-content: space-between;
		padding-bottom:50px;
	}

	.news-box .swiper-box{

	}

	.news-box .news-list{
		width:590px;
	}

	.news-box .news-list .title{
		padding-bottom: 15px;
		border-bottom: 1px solid #D9D9D9;
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.news-box .news-list .item-title{
		width:500px;
	}

	.line{
		width: 4px;
		height: 24px;
		background: linear-gradient(180deg, #1E22AA 0%, #0CB2EC 100%);
		opacity: 1;
		border-radius: 0px;
	}

	.hover-item:hover {
		border-bottom: 1px dotted #13B8EE;
	}

	.hover-item:hover a {
		color: #13B8EE;
	}

	.hover-a {
		color: #1A1A1A;
	}

	.hover-a:hover {
		color: #13B8EE;
	}

	.border-bottom-dott {
		border-bottom: 1px dotted #D9D9D9;
	}

	.feature{
		padding-top: 50px;
		padding-bottom: 50px;
	}

	.feature .contents{
		display: flex;
		flex-wrap: wrap;
		gap:30px;
		margin-top: 80px;
	}

	.feature .contents .item{
		width: 380px;
		background-color: #c1dcef;
		border: 2px solid #6b9cc4;
		border-radius:20px;
	}

	.feature .contents .item .item-title{
		width: 300px;
		height: 68px;
		background-color: #1651d9;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius:30px;
		margin-left:40px;
		margin-top:-34px;
	}

	.feature .contents .item .item-title .icon{
		width: 35px;
	}

	.feature .contents .item .item-title .text{
		font-size: 22px;
		margin-left: 10px;
		color: #fff;
	}

	.feature .contents .item .list{
		padding:15px;
		display: flex;
		flex-wrap: wrap;
		gap:10px;
	}

	.feature .contents .item .list .tag{
		background-color: #1d7fca;
		color: #fff;
		font-size: 16px;
		height: 56px;
		border-radius:30px;
		text-align:center;
		margin-top:10px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		line-height:56px;
	}

	.feature .contents .item .list .tags {
		background-color: #1d7fca;
		color: #fff;
		font-size: 16px;
		height: 60px;
		border-radius:30px;
		margin-top:10px;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		display: flex;
		flex-flow: column nowrap;
		justify-content: center;
		align-items: center;
	}

	.feature .contents .item .list .w-100{
		width: 100%;
	}

	.feature .contents .item .list .w-50{
		width: 48%;
	}

	.feature .contents .item .list .w-30{
		width:30.5%;
	}

	.zhengce{
		padding-top:50px;
		padding-bottom: 50px;
	}

	.zhengce .contents{
		display: flex;
		justify-content: space-between;
	}

	.zhengce .left{
		width: 790px;
	}

	.zhengce .left .top{
		display: flex;
		margin-top: 40px;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid #D9D9D9;
	}

	.zhengce .left .top .tabs{
		display: flex;
		margin-bottom:10px;
	}

	.zhengce .left .top .tabs .tab-item{
		padding:15px 30px;
		background-color: #afafaf;
		color: #fff;
		font-size:20px;
		border-radius: 8px;
		margin-right:20px;
		cursor: pointer;
	}

	.zhengce .left .top .tabs .active{
		background-color: #1651d9;
	}

	.zhengce .left .list{

	}

	.zhengce .left .list .item .item-title{
		display: flex;
	}
	.zhengce .left .list .item .item-title .hover-title{
		width: 500px;
	}

	.zhengce .left .list .item .tag{
		background-color: #de0323;
		color: #fff;
		font-size:12px;
		padding:5px 10px;
		border-radius:50px;
		margin-right:10px;
	}

	.zhengce .right{
		width: 380px;
		align-self:flex-start;
		background-color: #eff6fc;
	}

	.zhengce .contents .right .daikuan-title{
		width: 100%;
		height: 104px;
		background:url("../../assets/refined/daikuan_bg.png") no-repeat;
		color: #FFFFFF;
		padding:30px 20px;
		display: flex;
		flex-flow: column;
		justify-content: center;
	}

	.zhengce .contents .right .daikuan-title .title{
		font-size: 18px;
		font-weight: bold;
	}

	.zhengce .contents .right .daikuan-title .sub-title{
		font-size: 14px;
		margin-top:5px;
		color: #ffffff;
	}

	.zhengce .right .bank-list{
		margin:10px;
		display: flex;
		justify-content: space-between;
	}

	.zhengce .right .bank-list .bank-item{
		width: 175px;
		height: 337px;
		background-color: #fff;
		display: flex;
		flex-flow: column nowrap;
		align-items: center;
	}

	.zhengce .right .bank-list .bank-item .logo{
		width: 140px;
		height: 32px;
		margin-top: 20px;
		object-fit: cover;
	}

	.zhengce .right .bank-list .bank-item .name{
		font-size: 18px;
		color: #333;
		margin-top: 24px;
	}

	.zhengce .right .bank-list .bank-item .sub{
		margin-top: 24px;
		color: #666;
		font-size: 15px;
	}

	.zhengce .right .bank-list .bank-item .price{
		margin-top: 20px;
		color: #de021e;
		font-size: 13px;
		font-weight: bold;
	}



	.zhengce .right .bank-list .bank-item .lv-name{
		color: #666;
		font-size: 15px;
		margin-top: 20px;
	}

	.zhengce .right .bank-list .bank-item .lv-number{
		margin-top: 15px;
		color: #de021e;
		font-size: 13px;
		font-weight: bold;
	}

	.zhengce .right .bank-list .bank-item .btn{
		margin-top: 15px;
		width: 128px;
		height: 30px;
		background-color: #1651d9;
		color: #fff;
		text-align: center;
		line-height: 30px;
		border-radius: 30px;
		cursor: pointer;
	}

	.active-box .contents{
		display: flex;
		justify-content: space-between;
		margin-top: 50px;
	}

	.active-box .contents .left{
		width: 790px;

	}

	.active-box .contents .left .active-item{
		display: flex;
		justify-content: space-between;
		margin-bottom:50px;
		cursor: pointer;
	}

	.active-box .contents .left .active-item:last-of-type{
		margin-bottom: 0px;
	}

	.active-box .contents .left .active-item .item-left{
		width: 345px;
	}

	.active-box .contents .left .active-item .item-left .thumb{
		width: 345px;
		height: 215px;
		object-fit: cover;
	}

	.active-box .contents .left .active-item .item-right{
		width: 414px;
		position: relative;
	}

	.active-box .contents .left .active-item .item-right .item-right-title{
		font-size:18px;
		color: #333;
		font-weight: bold;
	}

	.active-box .contents .left .active-item .item-right .time{
		margin-top: 30px;
		font-size:14px;
		color:#666;
	}

	.active-box .contents .left .active-item .item-right .address{
		margin-top: 5px;
	}

	.active-box .contents .left .active-item .item-right .btn{
		width: 85px;
		height: 25px;
		color: #fff;
		background-color: #1651d9;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 30px;
		position: absolute;
		right: 0;
		bottom:0;
		cursor: pointer;
	}

	.active-box .contents .left .active-item .item-right .btn-no{
		width: 85px;
		height: 25px;
		color: #fff;
		background-color: #a2a2a2;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 30px;
		position: absolute;
		right: 0;
		bottom:0;
		cursor: pointer;
	}


	.active-box .contents .right{
		width: 380px;
		background-color: #fff;
		align-self: flex-start;
	}

	.active-box .contents .right .right-title{
		font-size: 24px;
		color: #333;
		font-weight: bold;
		padding:20px;
	}

	.active-box .contents .right  .step{
		padding-left: 20px;
		padding-bottom: 20px;
		padding-right: 20px;
	}

	.active-box .btn-group{
		display: flex;
		justify-content: center;
		align-items: center;
		margin-top: 80px;
	}

	.active-box .btn-group .btn{
		background-color: #1651d9;
		color: #fff;
		width: 165px;
		height: 48px;
		font-size: 20px;
		border-radius: 30px;
		display: flex;
		justify-content: center;
		align-items: center;
		cursor: pointer;
	}

	.frame{
		width: 100%;
		/* min-height: 552px; */
	}
</style>



// WEBPACK FOOTER //
// src/pages/refined/index.vue